import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCreditCard, FaExclamationTriangle, FaShieldAlt, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const PaymentMethodRequiredModal = () => {
  const { showPaymentMethodRequiredModal, dismissPaymentMethodRequiredModal, handlePaymentMethodRequired, logout } = useAuth();

  if (!showPaymentMethodRequiredModal) return null;

  return (
    <Modal 
      show={showPaymentMethodRequiredModal} 
      onHide={dismissPaymentMethodRequiredModal}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      dialogClassName="payment-required-modal"
    >
      <style>{`
        .payment-required-modal .modal-content {
          border: none;
          border-radius: 20px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          overflow: hidden;
        }
        .payment-required-modal .modal-header {
          border: none;
          background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
          color: white;
          padding: 24px 32px 20px;
        }
        .payment-required-modal .modal-body {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          padding: 32px;
        }
        .payment-required-modal .modal-footer {
          border: none;
          background: #ffffff;
          padding: 24px 32px 32px;
        }
        .feature-item {
          transition: transform 0.2s ease-in-out;
        }
        .feature-item:hover {
          transform: translateX(5px);
        }
        .add-payment-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4) !important;
        }
        .warning-icon {
          animation: pulse 2s infinite;
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }
      `}</style>
      
      <Modal.Header className="text-center">
        <div className="w-100">
          <div className="d-flex align-items-center justify-content-center mb-3">
            <FaExclamationTriangle className="warning-icon" size={32} />
          </div>
          <Modal.Title className="h3 mb-0 font-weight-bold">
            Payment Method Required
          </Modal.Title>
        </div>
      </Modal.Header>
      
      <Modal.Body>
        <div className="text-center">
          <div className="mb-4">
            <FaCreditCard size={64} className="text-warning mb-3" />
          </div>
          
          <h4 className="text-dark mb-3">
            <strong>Add a Payment Method to Continue</strong>
          </h4>
          
          <p className="text-muted mb-4 lead">
            Your account requires a valid payment method to access SmartClose features. 
            Please add a payment method to continue using the platform.
          </p>
          
          <div className="row text-left">
            <div className="col-md-6">
              <div className="feature-item mb-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <FaShieldAlt className="text-success mr-3" size={20} />
                  <div>
                    <strong>Secure Payments</strong>
                    <div className="text-muted small">Protected by Stripe encryption</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="feature-item mb-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <FaCreditCard className="text-primary mr-3" size={20} />
                  <div>
                    <strong>All Major Cards</strong>
                    <div className="text-muted small">Visa, MasterCard, American Express</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="alert alert-warning mt-4" role="alert">
            <FaExclamationTriangle className="mr-2" />
            <strong>Important:</strong> You cannot access SmartClose features without a valid payment method.
          </div>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="d-flex justify-content-between">
        <Button 
          variant="outline-secondary" 
          onClick={() => logout()}
          className="d-flex align-items-center"
        >
          <FaSignOutAlt className="mr-2" />
          Sign Out
        </Button>
        
        <Button 
          variant="warning"
          onClick={handlePaymentMethodRequired}
          className="add-payment-button d-flex align-items-center px-4 py-2"
          style={{
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            border: 'none',
            borderRadius: '25px',
            fontWeight: '600',
            boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)',
            transition: 'all 0.3s ease'
          }}
        >
          <FaCreditCard className="mr-2" />
          Add Payment Method
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentMethodRequiredModal;